import { AppThunkDispatch } from '@Reducers/index';

import { FormFieldsApi, ICurrency } from '@ClientApi/formFields';

export const SET_CURRENCIES = 'SET_CURRENCIES';

export class SetCurrencies {
  readonly type = SET_CURRENCIES;
  readonly payload: any;

  constructor(currencies: ICurrency[]) {
    this.payload = currencies;
  }
}

export const getCurrencies = () => async (dispatch: AppThunkDispatch) => {
  const fetchedCurrencies = await FormFieldsApi.getCurrencies();
  dispatch(new SetCurrencies(fetchedCurrencies));
};

export type CurrenciesAction = SetCurrencies;
